var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4987 13.3332C6.11799 13.3332 4.9987 14.4525 4.9987 15.8332C4.9987 16.2934 5.37179 16.6665 5.83203 16.6665H14.1654C14.6256 16.6665 14.9987 16.2934 14.9987 15.8332C14.9987 14.4525 13.8794 13.3332 12.4987 13.3332H7.4987ZM3.33203 15.8332C3.33203 13.532 5.19751 11.6665 7.4987 11.6665H12.4987C14.7999 11.6665 16.6654 13.532 16.6654 15.8332C16.6654 17.2139 15.5461 18.3332 14.1654 18.3332H5.83203C4.45132 18.3332 3.33203 17.2139 3.33203 15.8332Z",
    fill: "#393B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9987 3.33317C8.61799 3.33317 7.4987 4.45246 7.4987 5.83317C7.4987 7.21388 8.61799 8.33317 9.9987 8.33317C11.3794 8.33317 12.4987 7.21388 12.4987 5.83317C12.4987 4.45246 11.3794 3.33317 9.9987 3.33317ZM5.83203 5.83317C5.83203 3.53198 7.69751 1.6665 9.9987 1.6665C12.2999 1.6665 14.1654 3.53198 14.1654 5.83317C14.1654 8.13436 12.2999 9.99984 9.9987 9.99984C7.69751 9.99984 5.83203 8.13436 5.83203 5.83317Z",
    fill: "#393B4A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.53c084152deed9ed351e7d03d0e386b2.svg";
export { ForwardRef as ReactComponent };